<template>
	<div>
		<PageHeaderLayout>
			<div class="main-page-content">
				<el-row class="table-search">
					<el-form :inline="true" :model="searchCondition" class="demo-form-inline">
						<el-form-item v-for="item in searchList" :key="item.props" :label="item.label">
							<el-input
								v-if="item.type === 'input'"
								v-model="searchCondition[item.props]"
								:placeholder="'请输入' + item.label"
								clearable
							></el-input>
							<el-select
								v-if="item.type === 'select'"
								v-model="searchCondition[item.props]"
								:placeholder="'请选择' + item.label"
								clearable
							>
								<el-option v-for="option in item.selectData" :key="option.value" :label="option.label" :value="option.value"></el-option>
							</el-select>
							<DatePicker v-if="item.type === 'date'" @dataSearch="dataSearch(item.props, $event)" />
						</el-form-item>
						<el-form-item>
							<el-button type="primary" @click="searchButton">查询</el-button>
						</el-form-item>
					</el-form>
				</el-row>
				<ApeTable
					ref="apeTable"
					:data="tableData"
					:columns="columns"
					:loading="loadingStaus"
					:pagingData="pagingData"
					@switchPaging="switchPaging"
					highlight-current-row
				>
					<el-table-column label="操作" width="120" align="center" fixed="right">
						<template slot-scope="scope">
							<el-button v-if="scope.row.audit_status == 0" type="text" size="mini" @click="openDetail(scope.row, 'review')">审核</el-button>
							<el-button v-else type="text" size="mini" @click="openDetail(scope.row, 'detail')">查看</el-button>
						</template>
					</el-table-column>
				</ApeTable>
			</div>
		</PageHeaderLayout>

		<el-dialog title="详情" :visible.sync="detailVisible" width="680px">
			<el-form label-width="110px" class="detail-form">
				<el-form-item label="课程名称">
					<el-input :value="detailData.course_name || '-'" disabled></el-input>
				</el-form-item>
				<el-form-item label="课程时间">
					<el-input :value="detailCourseTime" disabled></el-input>
				</el-form-item>
				<el-form-item label="授课形式">
					<el-input :value="detailData.teach_mode_text || '-'" disabled></el-input>
				</el-form-item>
				<el-form-item label="课程状态">
					<el-input :value="detailData.course_status_text || '-'" disabled></el-input>
				</el-form-item>
				<el-form-item label="课程费用">
					<el-input :value="detailData.course_fee_text || '-'" disabled></el-input>
				</el-form-item>
				<el-form-item label="课程封面图">
					<img v-if="detailData.cover" :src="detailData.cover" class="cover-img">
					<span v-else>-</span>
				</el-form-item>
				<el-form-item label="联系人">
					<el-input :value="detailData.contact_name || '-'" disabled></el-input>
				</el-form-item>
				<el-form-item label="联系人电话">
					<el-input :value="detailData.contact_mobile || '-'" disabled></el-input>
				</el-form-item>
				<el-form-item label="详细地址">
					<el-input :value="detailData.address || '-'" disabled></el-input>
				</el-form-item>
				<el-form-item label="课程介绍">
					<div class="description" v-html="detailData.description || '-'"></div>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="detailVisible = false">取 消</el-button>
				<el-button v-if="detailMode === 'review'" type="primary" @click="auditVisible = true">审 核</el-button>
			</span>
		</el-dialog>

		<el-dialog title="审核" :visible.sync="auditVisible" width="420px">
			<el-radio-group v-model="auditForm.audit_status">
				<el-radio :label="1">审核通过</el-radio>
				<el-radio :label="2">审核拒绝</el-radio>
			</el-radio-group>
			<el-input
				v-if="auditForm.audit_status === 2"
				v-model="auditForm.audit_reject_reason"
				class="reject-textarea"
				type="textarea"
				:rows="4"
				placeholder="请输入拒绝原因"
			></el-input>
			<span slot="footer" class="dialog-footer">
				<el-button @click="auditVisible = false">取 消</el-button>
				<el-button type="primary" @click="confirmAudit">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import ApeTable from '@/components/ApeTable'
import DatePicker from '@/components/DatePicker.vue'
import { search_list, tableColumns } from './config/courseReview.ts'

export default {
	name: 'CourseReview',
	components: {
		PageHeaderLayout,
		ApeTable,
		DatePicker
	},
	data() {
		return {
			searchCondition: {},
			searchList: search_list,
			columns: tableColumns,
			loadingStaus: true,
			tableData: [],
			pagingData: {
				is_show: true,
				layout: 'total, sizes, prev, pager, next, jumper',
				total: 0
			},
			detailVisible: false,
			auditVisible: false,
			detailMode: 'detail',
			currentRow: {},
			detailData: {},
			auditForm: {
				audit_status: 1,
				audit_reject_reason: ''
			}
		}
	},
	computed: {
		detailCourseTime() {
			return [this.detailData.course_start_time, this.detailData.course_end_time].filter(Boolean).join(' 至 ') || '-'
		}
	},
	methods: {
		dataSearch(prop, value) {
			this.searchCondition[prop] = value
		},
		searchButton() {
			this.initList('search')
		},
		switchPaging() {
			this.initList()
		},
		getSearchParams() {
			const params = { ...this.searchCondition }
			if (params.course_time && params.course_time.length) {
				params.start_time = params.course_time[0]
				params.end_time = params.course_time[1]
				delete params.course_time
			}
			return params
		},
		formatList(list) {
			const statusMap = { 0: '待审核', 1: '审核通过', 2: '审核拒绝' }
			return list.map(item => ({
				...item,
				audit_status_text: statusMap[item.audit_status] || '-'
			}))
		},
		async initList(type) {
			this.loadingStaus = true
			const pagingInfo = this.$refs.apeTable.getPagingInfo(type)
			if (type === 'search') {
				pagingInfo.current_page = 1
			}
			try {
				const res = await this.$api.getCourseReviewList({
					...this.getSearchParams(),
					...pagingInfo
				})
				const list = res.data || res.list || []
				const pages = res.pages || { total: res.total || 0, offset: res.offset || 0 }
				this.tableData = this.formatList(list)
				this.pagingData.total = pages.total || 0
				this.pagingData.offset = pages.offset || 0
			} catch (e) {
				this.tableData = []
				this.$message.error(e.message || '获取课程审核列表失败')
			}
			this.loadingStaus = false
		},
		async openDetail(row, mode) {
			this.currentRow = row
			this.detailMode = mode
			this.auditForm = {
				audit_status: 1,
				audit_reject_reason: ''
			}
			try {
				const res = await this.$api.getCourseReviewDetail(row.id)
				this.detailData = res || row
			} catch (e) {
				this.detailData = row
			}
			this.detailVisible = true
		},
		async confirmAudit() {
			if (this.auditForm.audit_status === 2 && !this.auditForm.audit_reject_reason) {
				this.$message.warning('请输入拒绝原因')
				return
			}
			try {
				await this.$api.examineCourseReview(this.currentRow.id, this.auditForm)
				this.$message.success('操作成功')
				this.auditVisible = false
				this.detailVisible = false
				this.initList()
			} catch (e) {
				this.$message.error(e.message || '审核失败')
			}
		}
	},
	mounted() {
		this.initList()
	}
}
</script>

<style lang="scss" scoped>
.table-search {
	margin-bottom: 16px;
}
.cover-img {
	width: 120px;
	height: 120px;
	object-fit: cover;
}
.description {
	max-height: 220px;
	overflow: auto;
	line-height: 26px;
	/deep/ img {
		max-width: 100%;
	}
}
.reject-textarea {
	margin-top: 16px;
}
</style>
